import { createTheme } from '@mui/material/styles'
import ThemeConfig from '../../../theme/ThemeConfig'

const AppBarInputFieldTheme = createTheme({
  overrides: {
    MuiFormLabel: {
      root: {
        lineHeight: 1,
        fontSize: ThemeConfig.typography.inputText.fontSize,
        color: '#fff',
        '&$focused': {
          color: '#fff',
          lineHeight: 1,
        },
        '&.Mui-error': {
          color: ThemeConfig.palette.error.main,
        },
      },
      focused: {},
    },
    MuiInputLabel: {
      shrink: {
        lineHeight: 1,
        fontSize: ThemeConfig.typography.inputText.fontSize,
        '&.Mui-error': {
          color: ThemeConfig.palette.error.main,
        },
      },
    },
    MuiOutlinedInput: {
      notchedOutline: {
        borderColor: '#fff',
      },
      root: {
        height: 40,
        fontSize: ThemeConfig.typography.body1.fontSize,
        '&:hover:not($disabled):not($focused):not($error) $notchedOutline': {
          borderColor: '#fff',
        },
        '&$focused $notchedOutline': {
          borderColor: '#fff',
        },
        '&$disabled': {
          backgroundColor: '#fff',
        },
        '&.Mui-error': {
          color: ThemeConfig.palette.error.main,
          '&.Mui-focused fieldset': {
            borderColor: ThemeConfig.palette.error.main,
          },
        },
      },
    },
  },
})

export default AppBarInputFieldTheme
